import ApiServices from '@/services/api'
import globalMixin from '@/mixins'
let that = globalMixin.methods

// ---------->>>>>>>>>>>>>>>   all co-prop api call   <<<<<<<<<<<<<<------------
const ALL_CO_PROP_LIST = ({commit}) => {
  return ApiServices.getCoPropList()
    .then(response => {
      commit('getCoPropList', response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// ---------->>>>>>>>>>>>>>>   all co-prop api call   <<<<<<<<<<<<<<------------
const ALL_METER_LIST = ({commit}, config) => {
  return ApiServices.getMeterList(config)
    .then(response => {
      commit('getMeterList', response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// ---------->>>>>>>>>>>>>>>   all co-prop lot list api call   <<<<<<<<<<<<<<------------
const ALL_LOT_LIST = ({
  commit
}, data) => {
  return ApiServices.getLotList(data)
    .then(response => {
      commit('getLotList', response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// ---------->>>>>>>>>>>>>>>   all Address book based on site and meter ID api call   <<<<<<<<<<<<<<------------
const ALL_ADDRESS_BOOK = ({commit}, data) => {
  return ApiServices.getAddressBook(data)
    .then(response => {
      commit('getAddressBook', response)
      // that.SUCCESS_TOAST_MSG(response.message)
    })
}

// ---------->>>>>>>>>>>>>>>   all Address book based on site and meter ID api call   <<<<<<<<<<<<<<------------
const UPDATE_ADDRESS_BOOK = ({ commit }, data) => {
  return ApiServices.updateAddressBook(data)
    .then(response => {
      // commit('updateAddressBook', response)
      that.SUCCESS_TOAST_MSG(response.message)
    })
}
const PREVIOUS_UNIT_ADHOC_LOT = ({commit}, data) => {
  return ApiServices.previousUnitAdhocLot(data)
    .then(response => {
      commit('lotPreviousStatus', response)
    })
}
const LANDING_PAGE_COUNT = ({commit}) => {
  return ApiServices.landingPageCount()
    .then(response => {
      commit('updateLandingPage', response)
    })
}
const COMPLETED_SESSION_HOME = ({commit}) => {
  return ApiServices.completedSessionHome()
    .then(response => {
      commit('updateCompletedSessionHome', response)
    })
}
export default {
  ALL_CO_PROP_LIST,
  ALL_METER_LIST,
  ALL_LOT_LIST,
  ALL_ADDRESS_BOOK,
  UPDATE_ADDRESS_BOOK,
  PREVIOUS_UNIT_ADHOC_LOT,
  LANDING_PAGE_COUNT,
  COMPLETED_SESSION_HOME
}



// WEBPACK FOOTER //
// ./src/store/modules/coprops/actions.js